import { type FC } from 'react';

type PlayArrow36CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow36CircleFilled: FC<PlayArrow36CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
        >
            <circle cx="18" cy="18" r="18" fill="#666666" />
            <path
                d="M18 0C8.064 0 0 8.064 0 18C0 27.936 8.064 36 18 36C27.936 36 36 27.936 36 18C36 8.064 27.936 0 18 0ZM19.152 21.6576L11.9664 25.3152V10.6704L19.152 14.3424L26.3376 18L19.152 21.6576Z"
                fill="white"
            />
        </svg>
    );
};

export default PlayArrow36CircleFilled;
